import {
    Component,
    OnInit,
    ChangeDetectorRef,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { DataService } from 'src/app/services/data.service';
import { Constants } from 'src/app/core/constants';
import { ProposalImage } from 'src/app/models/proposal-image';
import { FileToBeUploaded } from 'src/app/models/internal/file-tobe-uploaded';

class FileUploadSnippet {
    pending: boolean = false;
    status: string = 'init';

    constructor(public src: string, public file: File) {}
}


@Component({
    selector: 'app-imageupload',
    templateUrl: './imageupload.component.html',
    styleUrls: ['./imageupload.component.scss'],
})
export class ImageuploadComponent implements OnInit {
    imageuploadForm = this.fb.group({
        file: [null, Validators.required],
    });
    @Input() proposalId: number;
    @Input() imageType: number; // part or package image
    @Input() OkTOUploadImages: boolean;
    // uploadedImage: ProposalImage;
    @Output() private imageUploaded: EventEmitter<FileToBeUploaded> = new EventEmitter<
    FileToBeUploaded
    >();
    @Output() private invalidImageUploaded: EventEmitter<string> = new EventEmitter<
    string
    >();
    @Input() isUpdateMode: boolean;
    fileStream = '';

    selectedFile: FileUploadSnippet;
    // selectedFile: File; //[] = [];
    constructor(
        private fb: FormBuilder,
        private toastService: ToastService,
        private cd: ChangeDetectorRef,
        private dataService: DataService
    ) {}

    ngOnInit() {}

    onFileChanged(imageInput: any) {
        const file: File = imageInput.files[0];
        const fileType = file['type'];
        const validImageTypes = ['image/gif', 'image/jpeg', 'image/jpg', , 'image/jfif', 'image/bmp', 'image/tif', 'image/tiff', 'image/webp'];
        if (!validImageTypes.includes(fileType)) {
            this.invalidImageUploaded.emit('Invalid file type selected. Please upload documents using \'Documents\' section');
            return;
        }
        const reader = new FileReader();

        reader.addEventListener('load', (event: any) => {
            this.selectedFile = new FileUploadSnippet(event.target.result, file);
            this.fileStream = event.target.result;
            this.selectedFile.pending = true;
            const imageToBeUploaded: FileToBeUploaded = {
                File: this.fileStream,
                Type: this.imageType,
                FileName: file.name,
                Category: 0,
                Url: this.fileStream
            }
            this.imageUploaded.emit(imageToBeUploaded);
        });
        reader.readAsDataURL(file);
    }

    // onSelectFile(event: HTMLInputEvent) {
    //     if (event.target.files && event.target.files[0]) {
    //       var reader = new FileReader();
    
    //       reader.readAsDataURL(event.target.files[0]); // read file as data url
    
    //       reader.onload = (event) => { // called once readAsDataURL is completed
    //         this.fileStream = JSON.parse(event.target.result);
    //         const imageToBeUploaded: ImageToBeUploaded = {
    //                         File: this.fileStream,
    //                         Type: this.imageType
    //                     }
    //                     this.imageUploaded.emit(imageToBeUploaded);
    //       }
    //     }
    // }

    // selectFileClick() {
    //     // first check if all other tabs are valid
    //     let element: HTMLElement = document.getElementById(
    //         'partImageSelector'
    //     ) as HTMLElement;
    //     element.click();
    // }

    onFileChanged_old(event) {
        this.selectedFile = event.target.file;
        const reader = new FileReader();

        if (event.target.files && event.target.files.length) {
            const [file] = event.target.files;
            reader.readAsDataURL(file);

            reader.onload = () => {
                this.imageuploadForm.patchValue({
                    file: reader.result,
                });

                // need to run CD since file load runs outside of zone
                this.cd.markForCheck();
            };
        }
    }
    // onUpload() {
    //     const uploadData = new FormData();
    //     // for (var i = 0; i < this.selectedFiles.length; i++) {
    //     //     uploadData.append('file', this.selectedFiles[i]);
    //     // }
    //     this.dataService.uploadFiles(this.selectedFile).subscribe(data => {
    //         if (data != null) {
    //             if (data && data['count'] == this.selectedFile.size) {
    //                 this.toastService.success(
    //                     'Package Template ' + Constants.SUCCESS_IMAGE_UPLOAD
    //                 );
    //             }
    //         }
    //     });
    // }
}
